import { Configuration, RetailersApi } from '@/api';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetRetailerQuery = (retailerId?: string, supplierId?: string) => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const retailersApi = new RetailersApi(new Configuration(auth));

  const queryKey = supplierId ? ['retailer', retailerId, supplierId] : ['retailer', retailerId];

  const {
    data: retailer,
    isLoading,
    error,
  } = useQuery({
    queryKey,
    queryFn: () => {
      if (!retailerId) throw new Error('Missing retailerId');
      return supplierId
        ? retailersApi.getRetailerWithSupplierContext(retailerId, supplierId)
        : retailersApi.getRetailer(retailerId);
    },
    enabled: !!retailerId,
  });

  const invalidateQuery = async (alsoInvalidateList = false) => {
    await queryClient.invalidateQueries({ queryKey });

    if (alsoInvalidateList) {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'retailers',
      });
    }
  };

  return {
    retailer,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetRetailerQuery;
